module.exports = __webpack_public_path__ + "static/media/10D.3f9bcd6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/10D.svg
// module id = 34
// module chunks = 0